// extracted by mini-css-extract-plugin
export default {"base":"user-select_base__nmcIE","user":"user-select_user__GHHtN"};